import { createStoreCreator } from 'lib/store'
import reducer from 'oee/dashboard/reducers'

export default createStoreCreator(reducer)
